import { Col, Row } from "@/styles/layout";
import { useMemo } from "react";
import { AiOutlineCopy } from "react-icons/ai";
import SyntaxHighlighter from "react-syntax-highlighter";
import { useBranding } from "@/hooks/useBranding";
import { toast } from "react-hot-toast";
import MyButton from "@/components/Button";
import { useAuth } from "@/providers/auth.provider";

const EmbeddableCode = () => {
  const { user } = useAuth();
  const { branding } = useBranding();

  const scriptCode = useMemo(
    () =>
      user
        ? `<script id="gogive-script" src="https://${
            process.env.NEXT_PUBLIC_STAGE === "prod" ? "" : "preview."
          }widget.gogive.com.au/bundle.js?id=${user.accountId}" defer></script>`
        : "",
    [user]
  );

  return (
    <Col>
      <Row
        alignItems="center"
        justifyContent={"space-between"}
        style={{ cursor: "pointer" }}
      >
        <SyntaxHighlighter
          language="html"
          wrapLongLines
          customStyle={{ fontSize: 14 }}
        >
          {scriptCode}
        </SyntaxHighlighter>
        <Row justifyContent={"flex-end"}>
          <MyButton
            variant="outline"
            Icon={AiOutlineCopy}
            label="Copy"
            onClick={() => {
              navigator.clipboard.writeText(scriptCode);
              toast.success("Script copied!");
            }}
            containerStyle={{ borderRadius: 8, px: 24, mr: 16 }}
            iconSize={18}
            labelStyle={{ fontSize: "16px" }}
          />
        </Row>
      </Row>
    </Col>
  );
};

export default EmbeddableCode;
